import { PositionType } from 'data/types';
import { WallRunType } from 'utils/space-wall-reconcile-types';
import { NearestWallRunType } from 'utils/wall-run-proximity-types';
import {
  pointAlongSegment,
  projectPointOnWallSegment
} from 'utils/wall-segment';

const SHARED_ENDPOINT_EPS_FT = 0.01;

function distanceBetween(a: PositionType, b: PositionType): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

function runEndpoints(run: WallRunType): [PositionType, PositionType] {
  return [run.segment.start, run.segment.end];
}

export function sharedEndpointDisplacementFt(
  previous: WallRunType,
  next: WallRunType
): number | null {
  const previousEnds = runEndpoints(previous);
  const nextEnds = runEndpoints(next);
  let best: number | null = null;

  for (let i = 0; i < previousEnds.length; i += 1) {
    for (let j = 0; j < nextEnds.length; j += 1) {
      const anchored =
        distanceBetween(previousEnds[i], nextEnds[j]) <= SHARED_ENDPOINT_EPS_FT;
      if (anchored) {
        const moved = distanceBetween(previousEnds[1 - i], nextEnds[1 - j]);
        if (best === null || moved < best) {
          best = moved;
        }
      }
    }
  }

  return best;
}

export function runMidpoint(run: WallRunType): PositionType {
  return pointAlongSegment(run.segment, run.lengthFt / 2);
}

export function nearestRunToPoint(
  runs: WallRunType[],
  point: PositionType
): NearestWallRunType | null {
  let best: NearestWallRunType | null = null;

  for (let runIndex = 0; runIndex < runs.length; runIndex += 1) {
    const projection = projectPointOnWallSegment(runs[runIndex].segment, point);
    if (!best || projection.distanceFt < best.distanceFt) {
      best = {
        runIndex,
        offsetFt: projection.offsetFt,
        distanceFt: projection.distanceFt
      };
    }
  }

  return best;
}
